export default __webpack_public_path__ + "static/media/blue-player.d2b713a3.png";